import React from "react";
import { useTranslations } from "next-intl";
import TravelFeatureCards, {
  TravelFeatureCard,
} from "@/app/components/common/TravelFeatureCards/TravelFeatureCards";

type Props = {
  features: TravelFeatureCard[];
  /** Tenant heading from Tenant Settings; falls back to the platform wording. */
  heading?: string;
};

const OfferSection = ({ features, heading }: Props) => {
  const t = useTranslations("HomePage");

  return (
    <section className="md:py-10 py-6">
      <div className="container mx-auto ">
        <div className="flex flex-col items-start gap-6">
          <h3 className="text-sleap-gray-950 dark:text-white text-[28px] leading-7 font-switzer font-bold mb-0">
            {heading || t("enhanceTravelExperience")}
          </h3>

          <div className="w-full flex flex-col gap-4">
            <TravelFeatureCards features={features} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
